import React, { useEffect } from "react";
import { APP_LINK_REQUEST_SUCCESS_EMAIL } from "../../CONSTANTS";
import { useSearchParams } from "react-router-dom";
import { isMobile } from "../../Utils";

function ChangeEmailSuccess() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("emailChangeValidationToken");

  useEffect(()=> {
    if (isMobile()){
      window.location.href = `${APP_LINK_REQUEST_SUCCESS_EMAIL}${token}`;
      return null;
    }
  }, [token])
  return null;
}

export default ChangeEmailSuccess;
